<template>
  <div>
    <!-- Common Component -->
    <b-container fluid>
     <BaseObject
        :object="object"
        :isNew="isNew"
        :payloads="basicItems"
        @input="reflectBasicItem"
      />
      <!-- Option components -->
      <!-- コミュニケーション図 -->
      <div>
        <h6 class="text-left">コミュニケーション図</h6>
        <b-container class="bottom-spacer clearfix">
          <div v-if="basicItems.image">
            <b-img
              v-if="!basicItems.image.match(/.pdf$/)"
              :src="`/public/${basicItems.image}`"
              width="150"
              class="communication_images"
              id="communication_image"
              @click="displayImage"
              left />
            <v-btn
              class="pdf_outline"
              v-else
              icon
              :href="`/public/${basicItems.image}`"
              target="_blank"
            >
                <b-img
                  id="communication_image"
                  class="communication_pdf_style communication_images"
                  :src="pdfIcon"
                />
            </v-btn>
            <b-popover
              target="communication_image"
              placement="top"
              :title="basicItems.image"
              triggers="hover focus"
              align-h="center"
              boundary="viewport"
            >
              <b-row align-h="center">
                <b-button variant="outline-danger" pill size="sm" @click="removeImage(basicItems.image)">削除</b-button>
              </b-row>
            </b-popover>
          </div>
        </b-container>
        <b-row align-h="center">
          <b-col sm="8">
            <b-form-file
              v-model="selecting_file"
              small
              placeholder="ファイルを選択してください"
              multiple
              browse-text="画像選択" />
            <b-button @click="putImage">追加</b-button>
          </b-col>
        </b-row>
      </div>
      <!-- 設計用コマンド -->
      <DesignCommand
        v-if="!isNew"
        :parent_id="basicItems.no"
        :items="basicItems.design_commands.items"
        :version="version"
        @refreshCommunicationDesign="refreshCommunicationDesign"
      />
      <!-- built in Component -->
      <b-row align-h="center">
        <template >
          <button type="button" class="btn btn-info button_spacer" v-if="isNew" @click="createCommunicationDesign">作成</button>
          <button type="button" class="btn btn-info button_spacer" @click="updateCommunicationDesign" v-else>変更</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <b-modal
        v-model="displayImageModal"
        size="xl"
        hide-footer
        hide-header
        scrollable
      >
        <img :src="modalImageUrl">
      </b-modal>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <router-link
            class="btn btn-outline-secondary"
            to="/"
          >はい</router-link>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import BaseObject from '../../common_parts/BaseObject.vue'
import DesignCommand from '../../common_parts/DesignCommand.vue'
import pdfIcon from '../../../assets/pdf_icon.png'
import { API, graphqlOperation, Storage } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'CommunicationDesign',
  components: {
    BaseObject,
    DesignCommand
  },
  data () {
    return {
      object: '',
      isNew: '',
      id: '',
      parent_id: '',
      selecting_file: [],
      basicItems: {
        no: '',
        version: '',
        name: '',
        revision_symbol: '',
        description: '',
        restrictions: '',
        image: '',
        design_commands: {
          items: []
        }
      },
      toast: {},
      displayResumeModal: false,
      displayImageModal: false,
      modalImageUrl: '',
      pdfIcon: pdfIcon,
      vue_app_origin: ''
    }
  },
  computed: {
    ...mapState(['version'])
  },
  async created () {
    this.object = this.$route.path.split('/')[1]
    this.id = this.$route.params.communicationDesignId
    // fetch basic object
    this.parent_id = this.$route.query.parent_id
    if (this.id) {
      this.isNew = false
      const comDesign = await API.graphql(graphqlOperation(`
        query getCommunicationDesign {
          getCommunicationDesign(no: ${this.id}, version: "${this.version}"){
            no
            version
            name
            revision_symbol
            description
            restrictions
            image
            design_commands {
              items {
                no
                design_sender
                design_destination
                frame_type
                communication_trigger
                assumed_frequency
                destination_integration
                properties {
                  no
                  name
                  description
                  property_size
                }
              }
            }
          }
        }
      `))
      // to check query result
      if (comDesign.data.getCommunicationDesign) {
        this.basicItems = { ...comDesign.data.getCommunicationDesign }
      } else {
        this.$router.push('/' + this.object)
      }
    } else {
      this.isNew = true
      // checking parrent_id exsit on url
      if (!this.$route.query.parent_id) {
        this.makeToast('parent_id', 'parent_idが指定されていません。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
      // checking parent_id is Integer
      if (!parseInt(this.$route.query.parent_id)) {
        this.makeToast('parent_id', '無効なparent_idです。', 'danger')
        setTimeout(function () {
          this.$router.go(-1)
        }.bind(this), 2000)
      }
    }
    this.vue_app_origin = process.env.VUE_APP_ORIGIN
  },
  methods: {
    reflectBasicItem (event) {
      this.basicItems = { ...event }
    },
    async putImage () {
      if (this.basicItems.image !== '' && this.basicItems.image !== 'null' && this.basicItems.image !== null) {
        this.makeToast('失敗', '登録済みの画像を削除してください', 'danger')
        return
      }
      const fileName = this.selecting_file[0].name
      try {
        const s3key = `${this.version}/${this.object}/${this.basicItems.no}/${fileName}`
        this.$log.debug(s3key)
        const result = await Storage.put(s3key, this.selecting_file[0], {
          contentType: this.selecting_file[0].type
        })
        this.basicItems.image = s3key
        this.$log.debug(result)
        this.makeToast('成功', '画像のアップロードに成功しました', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '画像のアップロードに失敗しました', 'danger')
      }
    },
    async removeImage (fileName) {
      try {
        await Storage.remove(fileName)
        this.basicItems.image = ''
        this.updateCommunicationDesignWithoutRefresh()
        this.makeToast('成功', '画像の削除に成功しました。', 'info')
      } catch {
        this.makeToast('失敗', '画像の削除に失敗しました。', 'danger')
      }
    },
    async updateCommunicationDesign () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? 'revision_symbol: null\n' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.image === '' || this.basicItems.image === null || this.basicItems.image === 'null' ? 'image: null\n' : `image: "${this.basicItems.image}"`
        const updateRequest = `mutation updateCommunicationDesign {
          updateCommunicationDesign(input:{
            ${requestBody}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
            image
          }
        }`
        this.$log.debug('=====CommunicationDesign Update Input=====', updateRequest)
        const response = await API.graphql(graphqlOperation(updateRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}更新が完了しました。`, 'info')
        this.$log.debug('=====CommunicationDesign Update Success=====', response)
        this.$router.go()
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====CommunicationDesign Update Error=====', e)
      }
    },
    async createCommunicationDesign () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? 'revision_symbol: null\n' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.image === '' || this.basicItems.image === null || this.basicItems.image === 'null' ? 'image: null\n' : `image: "${this.basicItems.image}"`
        const createRequest = `mutation createCommunicationDesign {
          createCommunicationDesign(input:{
            ${requestBody}
            usecase_no: ${this.parent_id}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====CommunicationDesign Create Input=====', createRequest)
        const response = await API.graphql(graphqlOperation(createRequest))
        this.makeToast('正常終了', `${this.translate[this.object]}作成が完了しました。`, 'info')
        this.$log.debug('=====CommunicationDesign Create=====', response)
        await this.$router.push(`/communication_design/${response.data.createCommunicationDesign.no}`)
        this.$router.go()
      } catch (e) {
        this.$log.debug('=====CommunicationDesign Create Error=====', e)
        const isConditionalError = e.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    },
    async refreshCommunicationDesign () {
      const comDesign = await API.graphql(graphqlOperation(`
        query getCommunicationDesign {
          getCommunicationDesign(no: ${this.id}, version: "${this.version}"){
            no
            version
            name
            revision_symbol
            description
            restrictions
            image
            design_commands {
              items {
                no
                design_sender
                design_destination
                frame_type
                communication_trigger
                assumed_frequency
                destination_integration
                properties {
                  no
                  name
                  description
                  property_size
                }
              }
            }
          }
        }
      `))
      // to check query result
      if (comDesign.data.getCommunicationDesign) {
        this.basicItems = { ...comDesign.data.getCommunicationDesign }
      } else {
        this.$router.push('/' + this.object)
      }
    },
    async updateCommunicationDesignWithoutRefresh () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.image === '' || this.basicItems.image === null || this.basicItems.image === 'null' ? 'image: null\n' : `image: "${this.basicItems.image}"`
        const updateRequest = `mutation updateCommunicationDesign {
          updateCommunicationDesign(input:{
            ${requestBody}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
            image
          }
        }`
        this.$log.debug('=====CommunicationDesign Update Input=====', updateRequest)
        const response = await API.graphql(graphqlOperation(updateRequest))
        this.$log.debug('=====CommunicationDesign Update Success=====', response)
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====CommunicationDesign Update Error=====', e)
      }
    },
    displayImage (image) {
      this.displayImageModal = true
      this.modalImageUrl = `https://communication-design.cloud-partner.site/public/${this.basicItems.image}`
    }
  }
}
</script>
<style>
  .communication_pdf_style {
    width: 60px;
  }
</style>
